/** Model + provider-config product events (spec 68 §6.6.3). */
import { z } from 'zod';
import { addRemoveEnum, DEFAULT_SCHEMA_VER, id } from './_shared.js';

export const modelEvents = {
  'model.allowed': {
    schema: z.object({ account_id: id, model_slug: id, op: addRemoveEnum }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
  'model.denied': {
    schema: z.object({ account_id: id, model_slug: id, op: addRemoveEnum }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
  'model.account_default_set': {
    schema: z.object({ account_id: id, model_slug: id }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
} as const;
